module.exports = __webpack_public_path__ + "img/logo.31e1a024.png";